<script>
	import { t } from '$lib/translations'
	import { Button, ListItem, UnorderedList } from '$lib/ui-woltair/components'
	export let items = []
	export let reviewAuthor = null
</script>

{#each items as item}
	<div class="item-container">
		<h2 class="mb-10">{item.title}</h2>
		<p>{item.subtitle}</p>
		<div class="section-wrapper">
			<section class="left-section">
				{#if item.productImage?.data?.attributes?.url}
					<img src={item.productImage.data.attributes.url} alt={item.title} />
				{/if}
				<UnorderedList>
					{#each item.unorderedList as ul}
						<ListItem icon="woltair">{ul.list}</ListItem>
					{/each}
				</UnorderedList>
				<Button href={item.button.url}>{item.button.text}</Button>
			</section>
			<section class="right-section">
				<div class="heading-review">
					{#if reviewAuthor?.data?.attributes}
						<img
							class="rated-by-img"
							src={reviewAuthor.data.attributes.photo.data.attributes.url}
							alt={reviewAuthor.data.attributes.name}
						/>

						<div class="rated-wrapper">
							<p>{t('web.brand_pages.expertReview.description')}</p>
							<p>{reviewAuthor.data.attributes.name}</p>
						</div>
					{/if}
				</div>
				{#each item.review as review}
					<p>{review.paragraph}</p>
				{/each}
			</section>
		</div>
	</div>
{/each}

<style lang="scss">
	.item-container {
		border-bottom: 1px solid #e4e4e4;
		padding: 50px 0;

		h2 {
			max-width: 60%;

			@media only screen and (max-width: 760px) {
				max-width: 100%;
			}
		}

		.section-wrapper {
			display: flex;

			@media only screen and (max-width: 760px) {
				flex-direction: column;
			}

			.left-section {
				width: 40%;

				@media only screen and (max-width: 760px) {
					width: 100%;
				}

				img {
					width: 300px;
					@media only screen and (max-width: 760px) {
						width: 100%;
					}
				}
			}

			.right-section {
				width: 50%;
				margin-left: 10%;

				@media only screen and (max-width: 760px) {
					width: 100%;
					margin-left: 0;
					margin-top: 30px;
				}

				.heading-review {
					display: flex;

					.rated-by-img {
						width: 50px;
						height: 50px;
						margin-right: 20px;
					}

					.rated-wrapper {
						display: flex;
						flex-direction: column;

						p:first-child {
							margin-top: 0px;
							font-weight: normal;
							margin-bottom: 0;
						}

						p:last-child {
							font-weight: bold;
							margin-top: 0;
							margin-bottom: 0;
						}
					}
				}

				p {
					font-weight: 300;
					margin-bottom: 1rem;
				}

				p:first-of-type {
					margin-top: 1rem;
				}
			}
		}
	}
</style>
